/** Export identity (issue #289) — who exported / printed a PDF, surfaced in
 *  the PDF footer alongside the "Designed using DrawLeather.com" branding.
 *
 *  The only identity the browser can obtain is the opaque account id from
 *  `/api/me` (the Startup API proxy forwards an account id, not a name or
 *  email — see worker/index.ts). An anonymous / local visitor has none, and
 *  any probe failure (offline, dev server, 4xx) is treated as "not signed in"
 *  rather than blocking the export. The result is cached for the session so a
 *  burst of exports / prints doesn't re-probe every time. */

let cached: Promise<string | null> | null = null;

export function fetchAccountId(): Promise<string | null> {
  if (!cached) {
    cached = fetch("/api/me")
      .then((r) =>
        r.ok ? (r.json() as Promise<{ accountId?: string | null }>) : null,
      )
      .then((body) => body?.accountId ?? null)
      .catch(() => null);
  }
  return cached;
}

/** Reset the cached probe — test seam only. */
export function __resetAccountCache(): void {
  cached = null;
}
